import React from 'react';
import { useSelector } from 'react-redux';
import { useCookies } from 'react-cookie';
import styled from 'styled-components';
import trans from '../components/trans';
import BackButton from '../components/BackButton';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router';

const Container = styled.div`
  background-color: #f4f5f7;
`;

const Block = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 20px 0px;
  @media (max-width: 1280px) {
    padding: 20px 15px;
  }
`;

export default function PrivacyPolicy({ history }) {
  const navigate = useNavigate()
  const footer = useSelector(state => state.footer)
  const [cookies, setCookie] = useCookies(['Opt-Out-Cookie']);
  const privacytitel = useSelector(state => state.footer && state.footer.data && state.footer.data.f384t_Web_Datenschutz_Titel)
  if (!footer || !footer.data) {
    return null;
  }

  return (
    <Container>
      <Block>
        <BackButton onClick={() => navigate(-1)} className="back-link">
          « {trans('BACK_TO_OVERVIEW')}
        </BackButton>
        <div dangerouslySetInnerHTML={{ __html: footer.data.f385t_Web_Datenschutz }} />
        <div>
          {trans('GOOGLE_ANALYTICS_INFO')}
          <br />
          {cookies["optOutCookie"] === 'true' ? (
            <button
              onClick={() => {
                setCookie('Opt-Out-Cookie', false);
                window.location.reload();
              }}
            >
              {trans('DIABLE_GOOGLE_ANALYTICS')}
            </button>
          ) : (
            <button
              onClick={() => {
                setCookie('Opt-Out-Cookie', true);
                window.location.reload();
              }}
            >
              {trans('ABLE_GOOGLE_ANALYTICS')}
            </button>
          )}
        </div>
      </Block>
      <Helmet title={privacytitel} />
    </Container>
  );
}
